<template>
  <div class="main-container group-table-height">
    <transition :css="false">
    <el-dialog title="Edit Group" :visible.sync="editModal" width="40%">
      <form>
        <div class="form-group">
          <label>Group Name</label>
          <input type="text" v-model="form.groupnamee" style="height:5rem" class="form-control"
 />
        </div><br />

        <div class="form-group">
          <label for="exampleFormControlTextarea1">Group Description</label>
          <textarea
            v-model="form.group_desc"
            class="form-control"
            id="exampleFormControlTextarea1"
            rows="3"
          ></textarea>
        </div>

        <div class="mt-5 form-check ml-3">
          <input
            class="form-check-input"
            v-model="form.status"
            type="checkbox"
            value=""
            id="defaultCheck1"
          />
          <label class="form-check-label" for="defaultCheck1">
            {{ form.status ? 'Disable Group' : 'Enable Group' }}
          </label>
        </div>
        <div class="pt-4 text-right">
          <div v-if="loader" className="text-center">
            <div class="submit-gif">
              <div
                class="spinner-border"
                style="width: 3rem; height: 3rem;"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <div v-else>
            <button class="btn btn-primary" @click="updateGroup">
              Edit Group
            </button>
          </div>
        </div>
      </form>
    </el-dialog>
    </transition>

    <div style="width: 100%;">
      <el-input
        style="max-width: 200px;"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :columns="fields"
        :rows="getGroups"
        :search-options="{ enabled: true, externalQuery: searchTerm }"
        :pagination-options="{ enabled: true }"
      >
        <template slot="table-row" slot-scope="props" style="background: red;">
          <!-- {{1}} -->

          <span v-if="props.column.field == 'actions'">
            <b-button
            :disabled="loading"
              size="md"
              variant="success"
              @click="editmodal(props.row.id)"
            >
              {{loading?"Loading...":"Edit Group"}} &nbsp;
              <span class="fa fa-wrench"></span>
            </b-button>
          </span>
          <span v-else>{{ props.row[props.column.field] }}</span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import ArnergyInput from '../kitchen/ArnergyInput.vue'
import VueSweetalert2 from 'vue-sweetalert2'
import Vue from 'vue'
import 'sweetalert2/dist/sweetalert2.min.css'
import moment from 'moment'
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  Dialog,
  RadioGroup,
  RadioButton,
  // ...
} from 'element-ui'
moment.updateLocale('en', {
  monthsShort: 'jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec'.split('_'),
})

const items = []
export default {
  components: {
    'el-dialog': Dialog,
    ArnergyInput,
    VueSweetalert2,
  },
  data() {
    return {
      searchTerm: '',
      selectOption: {
        enabled: true,
      },
      editModal: false,
      loader: false,
      form: {
        groupnamee: '',
        group_desc: '',
        status: false,
      },
      updateID: '',
      items: items,
      fields: [
        {
          field: 'id',
          label: 'ID',
          sortable: 'true',
        },

        {
          field: 'groupname',
          label: 'Group Name',
          sortable: 'true',
        },
        {
          field: 'groupdesc',
          label: 'Group Description',
          sortable: 'true',
        },
        {
          field: 'status',
          label: 'Status',
          sortable: 'true',
        },
        {
          field: 'actions',
          label: 'Actions',
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      ],

      currentPage: 1,
      details: ['UserDetails', 'allowUser'],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading:false,
      modalInfo: {
        title: '',
        content: '',
      },
    }
  },
  computed: {
    ...mapGetters([
      'getUserById',
      'getDeviceById',
      'getUsers',
      'getGroups',
      'getDummy',
      'getDevices',
    ]),
    isACxTeam: {
      get() {
        if (this.$can('am', 'cxTeam') || this.$can('edit', 'user')) {
          return true
        } else {
          return true
        }
      },
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return {
            text: f.label,
            value: f.key,
          }
        })
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('Do MMM YYYY')
    },
    navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user,
        },
      })
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`
      this.modalInfo.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    resetModal() {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    updateGroup(e) {
      e.preventDefault()
      const HTTP = this.$httpUtils.instance
      const data = {
        groupname: this.form.groupnamee,
        groupdesc: this.form.group_desc,
        status: this.form.status ? 1 : 0,
        id: this.updateID,
      }
    
        this.loader = true
        console.log(data)
        HTTP.put('/customerGroups', data)
          .then((res) => {
            if (res.data) {
              this.editModal = false
              this.showAlert()
              this.loader = false
              this.fetchUsers()
              this.form.groupnamee = ''
              this.form.group_desc = ''
              this.form.status = false
            }
          })
          .catch((err) => {
            console.log(err)
          })
      
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: 'Success',
        imageWidth: '40px',
        text: 'Group Updated Successfully',
        icon: 'success',
        width: '550px',
      })
    },
    fetchUsers() {
      const HTTP = this.$httpUtils.instance
      //  filter={"include": ["installations"]}
      const url = `/customerGroups
`
      HTTP.get(url)
        .then((response) => {
          const usersList = response.data
          this.$store.commit(
            'saveGroups',
            usersList.map((data) => ({
              id: data.id,
              groupname: data.groupname,
              groupdesc: data.groupdesc,
              status: data.status == 0 ? 'Disabled' : 'Enabled',
            })),
          )
          // console.log(this.getUserById(1))
        })
        .catch((error) => {
          console.log('error', error)
        })
    },

    editmodal(id) {
      this.updateID = id
         this.loading=true
      const HTTP = this.$httpUtils.instance
      const url = `/customerGroups/${id}`
      HTTP.get(url)
        .then((res) => {
          this.editModal = true
          this.form.groupnamee = res.data.groupname
          this.form.group_desc = res.data.groupdesc
          this.form.status = res.data.status
             this.loading=false
        })
        .catch((error) => {
          console.log('error', error)
             this.loading=false
        })
    },
  },
  mounted() {
    this.fetchUsers()
    // console.log(this.getDummy)
  },
}
</script>

<style scoped>
.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}
.group-table-height {
  height: calc(100vh - 450px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/user-mgt/GroupInfo.vue